// extracted by mini-css-extract-plugin
export default {"container":"Input_container__bW6GE","label":"Input_label__7rFLD","error":"Input_error__zNyXo"};